import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot} from '@angular/router';
import {environment} from '@environments/environment';
import {KeycloakService} from 'keycloak-angular';
import {AuthService} from './auth.service';

export const AuthGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const keycloak = inject(KeycloakService);
  const authenticated = keycloak.isLoggedIn();
  // const roles = keycloak.getUserRoles(true);
  // if (!environment.keycloak) {
  //     return true;
  // }

  // Force the user to log in if currently unauthenticated.
  if (!authenticated) {
    await keycloak.login({
      redirectUri: window.location.origin + (state.url ? '/#' : '') + state.url,
    });
  }
  return true;
};
